import { render, staticRenderFns } from "./ImageTable.vue?vue&type=template&id=d021c568&scoped=true"
import script from "./ImageTable.vue?vue&type=script&lang=js"
export * from "./ImageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d021c568",
  null
  
)

export default component.exports